<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>


<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="d-flex align-items-center">
            <h1 class="page-heading">
              <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
                <g filter="url(#filter0_d_901_1272)">
                  <path
                    d="M29.2087 1.18966L29.4028 0.285304C29.4527 0.13996 29.5525 0 29.7466 0H31.1218C31.3159 0 31.4657 0.145343 31.4657 0.285304L31.6597 1.18966C32.1034 1.33501 32.5414 1.57186 32.9351 1.90562L33.8168 1.57186C33.9666 1.52342 34.1606 1.57186 34.2605 1.76027L34.9481 2.90149C35.0479 3.04683 34.998 3.23524 34.8483 3.33214L34.1107 3.95119C34.1606 4.18805 34.2106 4.42491 34.2106 4.66714C34.2106 4.904 34.1606 5.14086 34.1107 5.3831L34.8483 5.95371C34.998 6.0506 35.0423 6.23901 34.9481 6.42742L34.2605 7.52019C34.1606 7.70859 33.9666 7.75704 33.8168 7.70859L32.9351 7.37484C32.5414 7.70859 32.1034 7.94545 31.6597 8.09079L31.4657 9.0436C31.4657 9.18895 31.3159 9.32891 31.1218 9.32891H29.7466C29.5525 9.32891 29.4527 9.18356 29.4028 9.0436L29.2087 8.09079C28.7651 7.94545 28.327 7.70859 27.9832 7.42329L27.0516 7.70859C26.9019 7.75704 26.7078 7.70859 26.608 7.56325L25.9703 6.42203C25.8705 6.23363 25.8705 6.03983 26.0202 5.94832L26.7577 5.37771C26.7078 5.14086 26.7078 4.904 26.7078 4.66714C26.7078 4.43029 26.7078 4.19343 26.7577 3.95119L26.0202 3.33214C25.8705 3.23524 25.8705 3.04683 25.9703 2.90149L26.608 1.76027C26.7078 1.61493 26.9019 1.52342 27.0516 1.57186L27.9832 1.90562C28.327 1.62031 28.7651 1.33501 29.2087 1.18966ZM5.18114 26.8509C4.98706 26.6625 4.98706 26.3772 5.18114 26.1834C5.33086 26.038 5.66912 26.038 5.81884 26.1834L6.99444 27.2762L9.30126 24.7999C9.49535 24.6546 9.78925 24.6115 9.98888 24.7999C10.183 24.9883 10.183 25.2736 10.0388 25.4674L7.34379 28.229V28.2774C7.1497 28.4228 6.85581 28.4658 6.65618 28.2774L5.18114 26.8509ZM10.427 23.8041C9.73934 23.1366 8.80774 22.7113 7.77632 22.7113C6.7449 22.7113 5.8133 23.1419 5.12569 23.8041C4.43808 24.4231 4 25.3759 4 26.3772C4 27.3784 4.44362 28.2828 5.12569 28.9503C5.80775 29.6178 6.7449 30 7.77632 30C8.80774 30 9.73934 29.6178 10.427 28.9503C11.1146 28.2828 11.5526 27.3784 11.5526 26.3772C11.5526 25.3759 11.1146 24.4231 10.427 23.8041ZM25.5322 1.90562C24.7503 1.33501 23.8631 0.90436 22.9315 0.570608C21.9001 0.236856 20.7744 0.0484474 19.5988 0.0484474C16.8539 0.0484474 14.353 1.09815 12.4898 2.90687C10.6765 4.66714 9.54526 7.09492 9.54526 9.75955C9.54526 12.1389 10.3271 14.0445 11.4584 15.6164C12.5397 17.1882 14.0092 18.5179 15.4787 19.6645H23.7134C25.2328 18.5232 26.7023 17.1882 27.7836 15.6164C28.8649 14.0929 29.5969 12.3327 29.6468 10.1418C29.1089 10.0933 28.6653 9.71111 28.5655 9.18895L28.4657 8.71523C28.2217 8.61834 28.022 8.47838 27.828 8.38148L27.34 8.52682C26.8021 8.71523 26.1644 8.47838 25.8705 7.95622L25.1829 6.86345C24.889 6.34129 24.9888 5.72223 25.4269 5.34003L25.8206 5.00628C25.8206 4.90938 25.8206 4.76942 25.8206 4.67253C25.8206 4.52718 25.8206 4.43567 25.8206 4.29033L25.4269 4.00502C24.9832 3.62282 24.889 2.95532 25.1829 2.48161L25.5322 1.90562ZM12.39 9.808C12.39 10.0449 12.1959 10.2387 11.9464 10.2387C11.7024 10.2387 11.5027 10.0502 11.5027 9.808C11.5027 9.66266 11.5526 9.5227 11.5526 9.33429C11.5526 9.18895 11.5526 9.04899 11.5526 8.90364C11.6025 8.66679 11.7966 8.52144 12.0406 8.52144C12.2846 8.56989 12.4842 8.7583 12.4343 8.99515C12.4343 9.1405 12.3844 9.28046 12.3844 9.37735C12.39 9.5227 12.39 9.66804 12.39 9.808ZM12.878 7.24027C12.7781 7.42867 12.5341 7.57402 12.3401 7.47712C12.0961 7.38023 11.9963 7.14337 12.0961 6.90651C12.39 6.1475 12.8336 5.43154 13.3715 4.81249C13.9094 4.14498 14.597 3.57438 15.3345 3.14373C15.5286 2.99838 15.7781 3.09528 15.9223 3.28907C16.0221 3.47748 15.9722 3.71972 15.7726 3.85968C15.1349 4.24188 14.5471 4.76404 14.0535 5.33465C13.5656 5.90526 13.1719 6.52431 12.878 7.24027ZM19.5988 6.71272C20.1367 6.71272 20.5803 6.90113 20.9241 7.18643C21.218 7.52019 21.462 7.9939 21.462 8.47299C21.462 8.94671 21.218 9.37736 20.9241 9.71111C20.5803 10.0449 20.1422 10.2333 19.5988 10.2333C19.1108 10.2333 18.6672 10.0449 18.3234 9.71111C17.9796 9.37736 17.7855 8.95209 17.7855 8.47299C17.7855 7.99928 17.9796 7.52019 18.3234 7.18643C18.6617 6.90651 19.1053 6.71272 19.5988 6.71272ZM20.2809 7.81087C20.1311 7.62246 19.8872 7.52557 19.5933 7.52557C19.3493 7.52557 19.1053 7.62246 18.9056 7.81087C18.7559 7.95622 18.6617 8.19307 18.6617 8.47838C18.6617 8.71523 18.7615 8.95209 18.9056 9.14588C19.0997 9.29122 19.3493 9.38274 19.5933 9.38274C19.8872 9.38274 20.1311 9.28584 20.2809 9.14588C20.475 8.95747 20.5748 8.71523 20.5748 8.47838C20.5748 8.18769 20.4805 7.95083 20.2809 7.81087ZM18.1737 13.0432H21.0683C21.9999 11.5198 22.4435 9.75955 22.1496 8.04235C21.9056 6.47048 21.1182 4.99551 19.5988 3.7574C18.1293 4.99551 17.292 6.47048 17.048 8.04235C16.7984 9.75955 17.1922 11.5198 18.1737 13.0432ZM21.7559 13.5708V15.2395C21.7559 15.4764 21.5618 15.6702 21.3123 15.6702H21.2125C21.2624 16.1008 21.2125 16.5261 21.0628 16.9568C20.8687 17.4789 20.475 17.958 19.8373 18.3833L19.5933 18.5717L19.3493 18.3833C18.7615 17.9526 18.3678 17.4789 18.1737 16.9568C17.9796 16.5261 17.9796 16.1008 18.024 15.6702H17.9241C17.6801 15.6702 17.4805 15.4818 17.4805 15.2395V13.5708L17.4306 13.4739L15.8114 14.5236C15.6173 14.6689 15.3678 14.6205 15.2236 14.4267C14.9297 14.0445 14.6857 13.6677 14.536 13.2855C14.3863 12.7633 14.292 12.2358 14.4362 11.7136C14.536 11.1915 14.8798 10.7124 15.4177 10.3355C15.6118 10.1902 15.8613 10.0502 16.1552 9.95335C16.0554 9.28584 16.1053 8.57527 16.2051 7.90777C16.499 6.09905 17.4805 4.33878 19.3437 2.86381L19.5877 2.6754L19.8816 2.86381C21.6949 4.33878 22.7263 6.09905 23.0202 7.90777C23.12 8.57527 23.12 9.28584 23.0701 9.95335C23.364 10.0502 23.608 10.1902 23.8077 10.3355C24.3455 10.7177 24.6394 11.1915 24.7892 11.7136C24.889 12.2358 24.8391 12.7633 24.6394 13.2855C24.4897 13.6677 24.2956 14.0445 24.0017 14.4267C23.852 14.6151 23.608 14.6636 23.4139 14.5236L21.7947 13.4739L21.7559 13.5708ZM20.3308 15.6648H18.9112C18.8114 15.9986 18.8613 16.3323 18.9611 16.6661C19.0609 16.9514 19.3049 17.2367 19.5988 17.522C19.9426 17.2367 20.1367 16.9514 20.2864 16.6661C20.3807 16.3323 20.3807 15.9986 20.3308 15.6648ZM20.8687 13.8561H18.3678V14.8089H20.8687V13.8561ZM16.3105 10.8093C16.1607 10.8577 16.0166 10.9546 15.9168 11.0461C15.5729 11.283 15.329 11.5683 15.279 11.902C15.1792 12.2358 15.2291 12.618 15.3789 12.9948C15.4787 13.1832 15.5729 13.4254 15.6728 13.6139L16.9981 12.7579C16.7042 12.1389 16.4602 11.4768 16.3105 10.8093ZM22.194 12.7579L23.5193 13.6139C23.669 13.4254 23.7633 13.1832 23.8631 12.9948C23.9629 12.6126 24.0128 12.2358 23.9629 11.902C23.8631 11.5683 23.669 11.283 23.3252 11.0461C23.1755 10.9492 23.0812 10.8577 22.9315 10.8093C22.7818 11.4768 22.5378 12.1389 22.194 12.7579ZM17.4861 27.8521C17.536 28.7565 18.0739 29.3271 18.7116 29.564C19.0055 29.7093 19.2994 29.7524 19.5933 29.7524C19.9371 29.7524 20.231 29.7039 20.475 29.564C21.1626 29.3271 21.7005 28.7565 21.7504 27.8521H17.4861ZM22.8816 23.3734H22.9315H24.0128C24.7004 23.3734 25.1884 22.9912 25.3381 22.5175C25.438 22.3291 25.4879 22.1353 25.4879 21.9469C25.4879 21.71 25.438 21.5162 25.3381 21.3278C25.1884 20.8541 24.7004 20.4719 24.0128 20.4719H15.2291C14.4916 20.4719 14.0535 20.8541 13.8539 21.3278C13.804 21.5162 13.7541 21.71 13.7541 21.9469C13.7541 22.1353 13.804 22.3291 13.8539 22.5175C14.048 22.9912 14.4916 23.3734 15.2291 23.3734H16.2606H16.3105H22.8816ZM16.3105 24.1863C15.6229 24.1863 15.1848 24.5685 14.9852 24.9937C14.8853 25.1821 14.8354 25.4244 14.8354 25.6128C14.8354 25.8012 14.8853 26.0434 14.9852 26.2318C15.1792 26.7055 15.6229 27.0393 16.3105 27.0393H22.8816C23.6191 27.0393 24.0572 26.7055 24.2568 26.2318C24.3067 26.0434 24.3566 25.8012 24.3566 25.6128C24.3566 25.4244 24.3067 25.1821 24.2568 24.9937C24.0627 24.5631 23.6191 24.1863 22.9315 24.1863H16.3105ZM30.4342 2.76153C29.3529 2.76153 28.4712 3.61744 28.4712 4.66714C28.4712 5.71685 29.3529 6.57276 30.4342 6.57276C31.5156 6.57276 32.3973 5.71685 32.3973 4.66714C32.3973 3.61744 31.51 2.76153 30.4342 2.76153Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_901_1272" x="0" y="0" width="39" height="38" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_901_1272" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_901_1272" result="shape" />
                  </filter>
                </defs>
              </svg>

              Projet
            </h1>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted ">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted"><a routerLink="/projets/liste" class="text-muted">Projets</a></li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">Détails projet</li>

            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->

    </div>
    <!-- end toolbar -->
    <!-- begin card details -->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <!--begin search form -->
        <form [formGroup]="formprojet">
          <div class="card">
            <!--begin::Card header-->

            <div class="card-body flex_input">
              <div class="title mb-10">
                <h4>Détails projet  
                  <i class="fa-regular fa-pen-to-square cursor-pointer update-icon" (click)="enabledetailproject()"></i>
                </h4>
              </div>
              <div class="container">
                <div class="row mb-3">
                  <div class="col-lg-6">
                    <label for=""> ID </label>
                    <input type="text" id="Nom" class="form-control form-control-solid mb-3"
                      formControlName="ID_project" readonly placeholder="ID" [readonly]="true"/>
                  </div>
                  <div class="col-lg-6">
                    <label for=""> Projet </label>
                    <input type="text" id="Nom" class="form-control  mb-3" formControlName="name"
                      placeholder="Projet x" [readonly]="isDisabled" />
                  </div>
                  <div class="col-lg-6">
                    <label for=""> Responsable </label>
                    <!-- (change)="getresponsable($event)" -->
                    <ng-select [items]="membres" bindLabel="name" [notFoundText]="'Aucun élément trouvé'" 
                      formControlName="manager_id" class="form-select mb-3"  placeholder="responsable" [readonly]="isDisabled">
                      <app-feild-error [control]="formprojet.get('manager_id')"
                        [controlName]="'manager_id'" ></app-feild-error>

                    </ng-select>

                  </div>


                  <div class="col-lg-6">
                    <label for=""> Date de début </label>
                    <input type="date" id="Nom" class="form-control  mb-3"  formControlName="start_date" placeholder="Date début" [readonly]="isDisabled"/>
                 
                  </div>
                  <div class="col-lg-6">
                    <label for=""> Date de fin </label>
                    <input type="date" id="Nom" class="form-control  mb-3" formControlName="end_date" placeholder="jj/mm/aaaa" [readonly]="isDisabled"/>
             
                    <div *ngIf="formprojet.hasError('dateRangeError')">
                      <span class="text-danger">{{ formprojet.getError('dateRangeError') }}</span>
                  </div>
                  </div>
                  <div class="col-lg-6">
                    <label for=""> Nombre des membres </label>
                    <input type="text" id="Nom" class="form-control form-control-solid mb-3"
                      formControlName="nbr_membres" placeholder="nbre membres" [readonly]="true" />
                  </div>



                  <div class="col-lg-6">
                    <div class="arrow-down">
                      <label for=""> Associer un nouveau membre </label>
                      <!-- (change)="removeResponsable($event)" -->
                      <ng-select   [items]="membresnv" bindLabel="name" bindValue="consultant_client_finals_id" [notFoundText]="'Aucun élément trouvé'" 
                      formControlName="membres" class="form-select mb-3" placeholder="membres" [multiple]="true"  [readonly]="isDisabled"
                      [closeOnSelect]="false" >
                      <app-feild-error [control]="formprojet.get('membres')" [controlName]="'membres'"></app-feild-error>
                    </ng-select>
                     
                    </div>

                    
                  </div>
                  <!-- <div class="row">
                  <div class="col-lg-6">
                    <div class="arrow-down">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="associerMembreCheckbox" (change)="onCheckboxChange($event)"[disabled]="isDisabled">
                        <label class="form-check-label" for="associerMembreCheckbox"> Associer des nouveaux membres en masse</label>
                      </div>
                  
                      <ng-select *ngIf="ischecked"  [items]="membresnv" bindLabel="name" bindValue="consultant_client_finals_id" [notFoundText]="'Aucun élément trouvé'"
                        formControlName="membres" class="form-select mb-3" placeholder="membres" [multiple]="true" [readonly]="isDisabled">
                        <app-feild-error [control]="formprojet.get('membresnv')" [controlName]="'membresnv'"></app-feild-error>
                      </ng-select>
                    </div>
                  </div>
                </div> -->


           
                  <div class="add mt-10">
                    <button class="save"  (click)="updateprojet()" [disabled]="isDisabled || formprojet.hasError('dateRangeError')"> Enregistrer</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!--end search form -->
      </div>
      <!--end::Content container-->
    </div>
    <!-- end card details -->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-5">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->
        <div class="card-body">
          <div class="header-grid align-items-center">
            <div class="section_title">
              <h1 class="section-heading my-0">Liste des membres</h1>
            </div>
            <!--end::Tab nav-->
            <!--begin::Wrapper-->

            <!--end::Wrapper-->
        </div>
          <!--end::Card header-->
          <!--begin::Card body-->
         
                <div class="content">
                  <div class="pt-3">
                    <!--begin::Table-->
                    <div class="table-responsive">
                      <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                        <thead>
                          <tr class="text-start text-dark-500 fw-bold fs-7 text-uppercase gs-0">
                            <th class="min-w-125px">Nom complet</th>
                            <th class="min-w-125px">Email</th>
                            <th class="min-w-90px">Action</th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-dark-400">
                          <tr *ngFor="let m of listmembrefinal">

                            <td>
                              <span *ngIf="m.type_membre === 'responsable'">{{m.first_name}} {{m.last_name}} ({{m.type_membre}})</span>
                              <span *ngIf="m.type_membre !== 'responsable'">{{m.first_name}} {{m.last_name}}</span>
                            </td>
                            <td><span>{{m.email}}</span></td>
                            <td _ngcontent-ng-c2375173677="" class="actions">
                              
                              <a _ngcontent-ng-c2375173677="" data-kt-menu-trigger="click" (click)="deletemembre(m)"
                                class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23"
                                  fill="none">
                                  <path
                                    d="M18.3004 5.09879H19.1502C19.3756 5.09879 19.5917 5.00926 19.7511 4.84989C19.9105 4.69052 20 4.47437 20 4.24899C20 4.02361 19.9105 3.80746 19.7511 3.64809C19.5917 3.48872 19.3756 3.39919 19.1502 3.39919H14.9012V2.54939C14.8992 1.87387 14.63 1.2266 14.1523 0.748929C13.6746 0.271262 13.0273 0.0020175 12.3518 0H7.25303C6.57751 0.0020175 5.93023 0.271262 5.45256 0.748929C4.97489 1.2266 4.70565 1.87387 4.70363 2.54939V3.39919H0.849798C0.624418 3.39919 0.408268 3.48872 0.2489 3.64809C0.0895318 3.80746 0 4.02361 0 4.24899C0 4.47437 0.0895318 4.69052 0.2489 4.84989C0.408268 5.00926 0.624418 5.09879 0.849798 5.09879H1.30444V17.8458C1.30444 18.9727 1.7521 20.0534 2.54894 20.8503C3.34578 21.6471 4.42653 22.0948 5.55343 22.0948H14.0514C15.1783 22.0948 16.2591 21.6471 17.0559 20.8503C17.8527 20.0534 18.3004 18.9727 18.3004 17.8458V5.09879ZM8.10283 16.1462C8.10283 16.3715 8.01329 16.5877 7.85393 16.7471C7.69456 16.9064 7.47841 16.996 7.25303 16.996C7.02765 16.996 6.8115 16.9064 6.65213 16.7471C6.49276 16.5877 6.40323 16.3715 6.40323 16.1462V9.34778C6.40323 9.1224 6.49276 8.90625 6.65213 8.74688C6.8115 8.58751 7.02765 8.49798 7.25303 8.49798C7.47841 8.49798 7.69456 8.58751 7.85393 8.74688C8.01329 8.90625 8.10283 9.1224 8.10283 9.34778V16.1462ZM13.2016 16.1462C13.2016 16.3715 13.1121 16.5877 12.9527 16.7471C12.7933 16.9064 12.5772 16.996 12.3518 16.996C12.1264 16.996 11.9103 16.9064 11.7509 16.7471C11.5915 16.5877 11.502 16.3715 11.502 16.1462V9.34778C11.502 9.1224 11.5915 8.90625 11.7509 8.74688C11.9103 8.58751 12.1264 8.49798 12.3518 8.49798C12.5772 8.49798 12.7933 8.58751 12.9527 8.74688C13.1121 8.90625 13.2016 9.1224 13.2016 9.34778V16.1462ZM13.2016 3.39919H6.40323V2.54939C6.40323 2.32401 6.49276 2.10786 6.65213 1.9485C6.8115 1.78913 7.02765 1.6996 7.25303 1.6996H12.3518C12.5772 1.6996 12.7933 1.78913 12.9527 1.9485C13.1121 2.10786 13.2016 2.32401 13.2016 2.54939V3.39919Z"
                                    fill="#EE6352" />
                                </svg>
                              </a>
                       
                            </td>

                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <div class="pagination" *ngIf="listmembrefinal && listmembrefinal.length">
                      <app-pagination [data]="listmembrefinal" [lengthData]="totalItems" (setPages)="getItems($event)"> </app-pagination>
                    </div>
                 
                  </div>
          
              
              <!--end::Tab pane-->
            <!--end::Table-->
          </div>
          <!--end::Card body-->
          

          <div class="alert alert-warning text-center mt-5" role="alert"
          *ngIf="listmembrefinal && !listmembrefinal.length">
          <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
          <span class="empty-list">
              La liste est vide
          </span>
      </div>

        </div>

        </div>
          </div>
      <!--end::Content container-->
    </div>
  </div>
</div>